var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#CC3333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.98-308q8.52 0 13.27-4.73t4.75-13.25q0-8.52-4.73-13.27T480.02-344q-8.52 0-13.27 4.73T462-326.02q0 8.52 4.73 13.27t13.25 4.75ZM470-430h22v-244h-22v244Zm10.44 298q-72.91 0-135.73-27.39-62.83-27.39-110.34-74.85-47.52-47.46-74.94-110.27Q132-407.33 132-480.33q0-71.99 27.39-135.39 27.39-63.4 74.85-110.41 47.46-47.02 110.27-74.44Q407.33-828 480.33-828q71.99 0 135.39 27.39 63.4 27.39 110.41 74.35 47.02 46.96 74.44 110.43Q828-552.35 828-480.44q0 72.91-27.39 135.73-27.39 62.83-74.35 110.16-46.96 47.33-110.43 74.94Q552.35-132 480.44-132Zm.06-22Q616-154 711-249t95-231.5Q806-616 711.19-711T480-806q-136 0-231 94.81T154-480q0 136 95 231t231.5 95Zm-.5-326Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureIcon);
export default __webpack_public_path__ + "static/media/failure-icon.2200c0e6f2095138337defe833c2c4a3.svg";
export { ForwardRef as ReactComponent };